import { render, staticRenderFns } from "./IconBtnWithBadge.vue?vue&type=template&id=6940abbc"
import script from "./IconBtnWithBadge.vue?vue&type=script&lang=js"
export * from "./IconBtnWithBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports